"use strict";
module.exports = ['$http', 'ngDroUAACommon', function ($http, ngDroUAACommon) {

        this.findOne = function (id, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/template/' + id)
            });
        };

        this.findAll = function (usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/template')
            });
        };

        this.delete = function (id, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'DELETE',
                url: ngDroUAACommon.getUrl('api/template/' + id),
                withCredentials: true
            });
        };

        this.save = function (params, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'POST',
                url: ngDroUAACommon.getUrl('api/template'),
                withCredentials: true,
                data: params
            });
        };

        this.update = function (params, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'PUT',
                url: ngDroUAACommon.getUrl('api/template'),
                withCredentials: true,
                data: params
            });
        };

        return {
            findAll: this.findAll,
            findOne: this.findOne,
            update: this.update,
            delete: this.delete,
            save: this.save
        };
    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/services/rest/template.js
// module id = 391
// module chunks = 0